import { curry, head } from 'ramda'

export const getInitials = str => {
  if (!str) return '--'

  if (str.includes(' ')) {
    str = str.split(' ').map(head).join('')
  }

  return str.substring(0, 2)
}

export const truncateString = curry((str, size) => {
  if (!!str && str.length > size) return str.substring(0, size) + '...'
  return str
})
export const truncate = truncateString
